// LoadingScreen.js
import React from "react";
import PuffLoader from "react-spinners/PuffLoader";
import { Box, useTheme } from "@mui/material";

const LoadingScreen = () => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.8)", // light overlay
        zIndex: 9999, // ensure it covers everything
      }}
    >
      <PuffLoader color={theme.palette.primary.main} size={100} />
    </Box>
  );
};

export default LoadingScreen;
